import { Link } from "react-router-dom";
import { Code, Puzzle, Rocket } from "lucide-react";
import Footer from "../components/footer";
import Seo from "../components/Seo";
import { useLang } from "../i18n/useLang";
import HeroImage from "../assets/btfhero-optimized.jpg";
import WorkWithTeamImage from "../assets/wwtsection-optimized.jpg";
import "../Styles/About.css";
import { localizedPath } from "../i18n/routes";

function About() {
  const { t, dir, lang } = useLang();
  const content = t.about;

  return (
    <>
      <Seo
        title={content.seo.title}
        description={content.seo.description}
      />

      <section className="section aboutPage">
        <div className="container aboutPage__shell" dir={dir}>
          <header className="aboutHero card">
            <div className="aboutHero__content">
              <p className="aboutHero__eyebrow">{content.hero.eyebrow}</p>
              <h1>{content.hero.title}</h1>
              <p className="aboutHero__lead">{content.hero.lead}</p>
            </div>
            <div className="aboutHero__media">
              <img
                src={HeroImage}
                alt="QuadroCode future builders"
                width="1200"
                height="800"
                fetchPriority="high"
                decoding="async"
              />
            </div>
          </header>

          <section className="aboutSection card">
            <div className="aboutSection__head">
              <p>{content.story.eyebrow}</p>
              <h2>{content.story.title}</h2>
            </div>
            {content.story.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </section>

          <section className="aboutSection card">
            <div className="aboutSection__head">
              <p>{content.vision.eyebrow}</p>
              <h2>{content.vision.title}</h2>
            </div>
            <p className="aboutQuote">{content.vision.quote}</p>
            {content.vision.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </section>

          <section className="aboutSection card">
            <div className="aboutSection__head">
              <p>{content.mentorship.eyebrow}</p>
              <h2>{content.mentorship.title}</h2>
            </div>
            {content.mentorship.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </section>

          <section className="aboutTimeline card" aria-label="QuadroCode journey timeline">
            <div className="aboutTimeline__labels" aria-hidden="true">
              <span>1992</span>
              <span>Today</span>
              <span>Future</span>
            </div>
            <div className="aboutTimeline__line" aria-hidden="true">
              <span className="aboutTimeline__dot" />
              <span className="aboutTimeline__dot" />
              <span className="aboutTimeline__dot" />
            </div>
          </section>

          <section className="aboutSection card">
            <div className="aboutSection__head">
              <p>{content.learning.eyebrow}</p>
              <h2>{content.learning.title}</h2>
            </div>
            <ul className="aboutList">
              <li>
                <span className="aboutList__icon" aria-hidden="true">
                  <Code size={18} />
                </span>
                <span>{content.learning.bullets[0]}</span>
              </li>
              <li>
                <span className="aboutList__icon" aria-hidden="true">
                  <Puzzle size={18} />
                </span>
                <span>{content.learning.bullets[1]}</span>
              </li>
              <li>
                <span className="aboutList__icon" aria-hidden="true">
                  <Rocket size={18} />
                </span>
                <span>{content.learning.bullets[2]}</span>
              </li>
            </ul>
            {content.learning.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
          </section>

          <section className="aboutSection card">
            <div className="aboutSection__head">
              <p>{content.future.eyebrow}</p>
              <h2>{content.future.title}</h2>
            </div>
            {content.future.paragraphs.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            <div className="aboutMission">
              <h3>{content.future.missionTitle}</h3>
              <p>{content.future.missionText}</p>
            </div>
          </section>

          <section
            className="aboutCta card"
          >
            <img
              className="aboutCta__background"
              src={WorkWithTeamImage}
              alt=""
              width="1200"
              height="800"
              loading="lazy"
              decoding="async"
              aria-hidden="true"
            />
            <div className="aboutCta__content">
              <p>{content.cta.eyebrow}</p>
              <h2>{content.cta.title}</h2>
              <p className="aboutCta__summary">{content.cta.text}</p>
              <div className="aboutCta__actions">
                <Link
                  to={`${localizedPath("/", lang)}#contact`}
                  className="btn btn-primary"
                  state={{ scrollTarget: "contact" }}
                  onClick={() => sessionStorage.setItem("qc_scroll_target", "contact")}
                >
                  {content.cta.primary}
                </Link>
                <Link
                  to={`${localizedPath("/", lang)}#services`}
                  className="btn"
                  state={{ scrollTarget: "services" }}
                  onClick={() => sessionStorage.setItem("qc_scroll_target", "services")}
                >
                  {content.cta.secondary}
                </Link>
              </div>
            </div>
          </section>
        </div>
      </section>

      <div className="container">
        <Footer showTopSections={false} />
      </div>
    </>
  );
}

export default About;
